export enum Flp360StatusEnum {
    'ACTIVE' = 1,
    'SUSPENDED' = 2,
    'TERMINATED' = 3
}

export enum MemberStatus {
    ACTIVE = 1,
    INCOMPLETE = 2,
    SUSPENDED = 3,
    TERMINATED = 4,
    DECLINED = 5,
    PENDING = 6,
    RESTRICTED = 7
}
